<template>
	<header>
		<div class="container">
			<img src="/static/resources/logo.png" class="logo">
		</div>
	</header>
</template>
<script type="text/javascript">
export default {
	name: "HeaderPartial",
	data() {
		return {
			
		}
	}
}
</script>

<style type="text/css" scoped>
	header {
		padding: 10px;
		background: #e0e0e0;
	}

	.logo {
		height: 60px;
		display: block;
		margin: auto;
	}
</style>